import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import _ from 'lodash';

const firebaseRef = firebase.database();
// @TODO
// 1. saveCientInfoData() : to only save form data
// 2. createSecondaryClient() : When an existing user, and add additional one
// 3. CcreateClientInfoFromCorporation() : user for corporation -> individual

export async function saveClientInfoData(
	leadId,
	section,
	formData,
	isNameChanged
) {
	// @param string: leadId
	// @param enum: section (individual || corporation)
	// @param object: formData {0:{id:'', firstName:'', ...}, 1: {...}} or {firstName:'', id:'', ...}
	// @param: isNameChanged: t/f
	const clientInfoRef = firebaseRef.ref(
		'/kavtek_agreements/' +
			PROJECT_CODE.projectCode +
			'/' +
			leadId +
			'/clientInfo/' +
			section
	);
	if (section === 'individual') {
		await clientInfoRef.once('value', (snapshot) => {
			let individualObjs = snapshot.val();
			let individualObjsKeys =
				individualObjs && Object.keys(individualObjs);
			if (formData?.hasOwnProperty('firstName')) {
				// 1. Individual User to sotre ONE purchaser
				let key = individualObjsKeys?.filter(
					(dbKey) => individualObjs[dbKey].id === formData?.id
				);
				if (isNameChanged && key) {
					// if change thier name, they need to start new verification step, so identification: null
					clientInfoRef.update({
						[key]: {
							...individualObjs[key],
							firstName: formData?.firstName,
							lastName: formData?.lastName,
							email: formData?.email,
							occupation: formData?.occupation,
							phoneNumber: formData?.phoneNumber,
							address1: formData?.address1,
							address2: formData?.address2,
							city: formData?.city,
							province: formData?.province,
							postalCode: formData?.postalCode,
							identification: null,
						},
					});
				} else if (key) {
					clientInfoRef.update({
						[key]: {
							...individualObjs[key],
							firstName: formData?.firstName,
							lastName: formData?.lastName,
							email: formData?.email,
							occupation: formData?.occupation,
							phoneNumber: formData?.phoneNumber,
							address1: formData?.address1,
							address2: formData?.address2,
							city: formData?.city,
							province: formData?.province,
							postalCode: formData?.postalCode,
						},
					});
				}
			} else {
				// 2. Individual User to store MORE THAN ONE(ALL) purchasers
				individualObjsKeys &&
					individualObjsKeys.map((dbKey) => {
						let formKey =
							formData &&
							Object.keys(formData)?.filter(
								(key) =>
									formData[key].id ===
									individualObjs[dbKey].id
							);
						formKey &&
							clientInfoRef.update({
								[dbKey]: {
									...individualObjs[dbKey],
									firstName:
										formData[formKey]?.firstName || '',
									lastName: formData[formKey]?.lastName || '',
									email: formData[formKey]?.email || '',
									occupation:
										formData[formKey]?.occupation || '',
									phoneNumber:
										formData[formKey]?.phoneNumber || '',
									address1: formData[formKey]?.address1 || '',
									address2: formData[formKey]?.address2 || '',
									city: formData[formKey]?.city || '',
									province: formData[formKey]?.province || '',
									postalCode:
										formData[formKey]?.postalCode || '',
								},
							});
					});
			}
		});
	} else {
		// 3. corporation user
		clientInfoRef.update(formData);
	}
}

export async function createSecondaryClient(leadId, formData, callback) {
	console.log('this is the second message');
	// @TODO: Create store empty data(set formData null) || Create and store data
	// @param string: leadId
	// @param object: formData {id:'', firstName:'', ...}, 1: {...}
	const clientInfoRef = firebaseRef.ref(
		'/kavtek_agreements/' +
			PROJECT_CODE.projectCode +
			'/' +
			leadId +
			'/clientInfo/individual'
	);
	let generateRefKey = await clientInfoRef.push();
	const uid = generateRefKey.key;

	await clientInfoRef.once('value', async (snapshot) => {
		let newIndex;
		let individualObjs = snapshot.val();

		let lastKey = individualObjs && Object.keys(individualObjs).pop();
		if (!isNaN(lastKey) && lastKey !== null) newIndex = Number(lastKey) + 1;
		else newIndex = 0;

		await clientInfoRef.update({
			[newIndex]: {
				firstName: formData?.firstName || '',
				lastName: formData?.lastName || '',
				email: formData?.email || '',
				occupation: formData?.occupation || '',
				phoneNumber: formData?.phoneNumber || '',
				address1: formData?.address1 || '',
				address2: formData?.address2 || '',
				city: formData?.city || '',
				province: formData?.province || '',
				postalCode: formData?.postalCode || '',
				isPrimary: false,
				id: uid,
			},
		});
		await clientInfoRef
			.orderByChild('id')
			.equalTo(uid)
			.limitToFirst(1)
			.once('value', async (snapshot) => {
				let snapData = snapshot.val();
				let removeEmpty = _.compact(snapData);
				console.log('snapdata', snapData, removeEmpty);
				callback(removeEmpty ? removeEmpty[0] : {});
			});

		// newIndex &&
		// 	clientInfoRef.child(newIndex).once('value', (snapshot) => {
		// 		let updateObj = snapshot.val();
		// 		console.log('updateObj', updateObj);
		// 		callback(updateObj ? updateObj : {});
		// 	});
	});
}

export async function createClientInfoFromCorporation(
	leadId,
	data,
	newForm,
	callback
) {
	const clientInfoRef = firebaseRef.ref(
		'/kavtek_agreements/' +
			PROJECT_CODE.projectCode +
			'/' +
			leadId +
			'/clientInfo'
	);
	// 1. delete corporation
	clientInfoRef.child('corporation').remove();
	// 2. create individual
	let generateRefKey = await clientInfoRef.push();
	let uid = generateRefKey.key;
	clientInfoRef.child('individual').update({
		[0]: {
			firstName: data?.firstName || '',
			lastName: data?.lastName || '',
			email: data?.email || '',
			occupation: data?.occupation || '',
			phoneNumber: data?.phoneNumber || '',
			address1: data?.address1 || '',
			address2: data?.address2 || '',
			city: data?.city || '',
			province: data?.province || '',
			postalCode: data?.postalCode || '',
			isPrimary: true,
			id: uid,
		},
	});
	//  3. check if second client form is added
	let newUid;
	if (newForm) {
		let generateNewRefKey = await clientInfoRef.push();
		newUid = generateNewRefKey.key;
		clientInfoRef.child('individual').update({
			[1]: {
				firstName: newForm?.firstName || '',
				lastName: newForm?.lastName || '',
				email: newForm?.email || '',
				occupation: newForm?.occupation || '',
				phoneNumber: newForm?.phoneNumber || '',
				address1: newForm?.address1 || '',
				address2: newForm?.address2 || '',
				city: newForm?.city || '',
				province: newForm?.province || '',
				postalCode: newForm?.postalCode || '',
				isPrimary: false,
				id: newUid,
			},
		});
	}
	callback({
		firstUid: uid,
		secondUid: newUid,
	});
}
export async function saveClientNamePurchaser(leadId, data) {
	let salesAgentKey;
	// 1. Update to kavtek_purchasers following info: clientFName, clientLName, clientEmail, clientPhoneNumber
	const purchaserRef = firebaseRef.ref(
		'/kavtek_purchasers/' + PROJECT_CODE.projectCode
	);
	const agreementRef = firebaseRef.ref(
		'/kavtek_agreements/' + PROJECT_CODE.projectCode
	);
	// 2-1. purchaserRef.id = leadId
	// 2-2. get salesAgentKey

	await purchaserRef.once('value', (snapshot) => {
		let salesAgents = snapshot.val();
		let salesAgentsKeys = salesAgents && Object?.keys(salesAgents);
		if (salesAgentsKeys?.length) {
			for (var i = 0; i < salesAgentsKeys.length; i++) {
				if (salesAgents[salesAgentsKeys[i]].hasOwnProperty(leadId)) {
					salesAgentKey = salesAgentsKeys[i];
					break;
				}
			}
		}
	});
	// 3. Update kavtek_purchasers
	salesAgentKey &&
		(await purchaserRef.child(salesAgentKey).child(leadId).update({
			clientFName: data?.firstName,
			clientLName: data?.lastName,
		}));
	// 4. Update agreement => leadDetails
	await agreementRef.child(leadId).child('leadDetails').update({
		clientFName: data?.firstName,
		clientLName: data?.lastName,
	});
}
